import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import MicroModal from 'micromodal';
import { Store } from '@ngxs/store';
import { Configuration } from 'remarketing-angular-library';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { takeUntil } from 'rxjs/operators';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-save-changes-modal',
    templateUrl: './save-changes-modal.component.html',
    styleUrls: ['./save-changes-modal.component.scss'],
    imports: [TranslocoDirective]
})
export class SaveChangesModalComponent extends SaComponent implements OnInit {
  configuration: Configuration;

  @Output() cancelEditing = new EventEmitter();
  @Output() continueEditing = new EventEmitter();

  @Input() modalId = 'save-changes-modal';

  constructor(private store: Store) {
    super();
  }

  ngOnInit() {
    this.store
      .select(_state => _state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(_configuration => (this.configuration = _configuration));
  }

  closeModal(type) {
    if (type === 'cancelEditing') {
      this.cancelEditing.next(true);
    } else if (type === 'continueEditing') {
      this.continueEditing.next(true);
    }
    MicroModal.close(this.modalId);
  }
}
